var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4 3.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m-1 5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0m1 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.25-5.75a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm-.5-3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m.5 4.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z",
    clipRule: "evenodd"
  })));
});
const SvgTextEditListsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTextEditListsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDMuNUM0IDMuNzc2MTQgMy43NzYxNCA0IDMuNSA0QzMuMjIzODYgNCAzIDMuNzc2MTQgMyAzLjVDMyAzLjIyMzg2IDMuMjIzODYgMyAzLjUgM0MzLjc3NjE0IDMgNCAzLjIyMzg2IDQgMy41Wk01IDMuNUM1IDQuMzI4NDMgNC4zMjg0MyA1IDMuNSA1QzIuNjcxNTcgNSAyIDQuMzI4NDMgMiAzLjVDMiAyLjY3MTU3IDIuNjcxNTcgMiAzLjUgMkM0LjMyODQzIDIgNSAyLjY3MTU3IDUgMy41Wk00IDguNUM0IDguNzc2MTQgMy43NzYxNCA5IDMuNSA5QzMuMjIzODYgOSAzIDguNzc2MTQgMyA4LjVDMyA4LjIyMzg2IDMuMjIzODYgOCAzLjUgOEMzLjc3NjE0IDggNCA4LjIyMzg2IDQgOC41Wk01IDguNUM1IDkuMzI4NDMgNC4zMjg0MyAxMCAzLjUgMTBDMi42NzE1NyAxMCAyIDkuMzI4NDMgMiA4LjVDMiA3LjY3MTU3IDIuNjcxNTcgNyAzLjUgN0M0LjMyODQzIDcgNSA3LjY3MTU3IDUgOC41Wk01LjI1IDIuNzVDNS4yNSAyLjQ3Mzg2IDUuNDczODYgMi4yNSA1Ljc1IDIuMjVIOS43NUMxMC4wMjYxIDIuMjUgMTAuMjUgMi40NzM4NiAxMC4yNSAyLjc1QzEwLjI1IDMuMDI2MTQgMTAuMDI2MSAzLjI1IDkuNzUgMy4yNUg1Ljc1QzUuNDczODYgMy4yNSA1LjI1IDMuMDI2MTQgNS4yNSAyLjc1Wk01Ljc1IDcuMjVDNS40NzM4NiA3LjI1IDUuMjUgNy40NzM4NiA1LjI1IDcuNzVDNS4yNSA4LjAyNjE0IDUuNDczODYgOC4yNSA1Ljc1IDguMjVIOS43NUMxMC4wMjYxIDguMjUgMTAuMjUgOC4wMjYxNCAxMC4yNSA3Ljc1QzEwLjI1IDcuNDczODYgMTAuMDI2MSA3LjI1IDkuNzUgNy4yNUg1Ljc1Wk01LjI1IDQuMjVDNS4yNSAzLjk3Mzg2IDUuNDczODYgMy43NSA1Ljc1IDMuNzVIOC43NUM5LjAyNjE0IDMuNzUgOS4yNSAzLjk3Mzg2IDkuMjUgNC4yNUM5LjI1IDQuNTI2MTQgOS4wMjYxNCA0Ljc1IDguNzUgNC43NUg1Ljc1QzUuNDczODYgNC43NSA1LjI1IDQuNTI2MTQgNS4yNSA0LjI1Wk01Ljc1IDguNzVDNS40NzM4NiA4Ljc1IDUuMjUgOC45NzM4NiA1LjI1IDkuMjVDNS4yNSA5LjUyNjE0IDUuNDczODYgOS43NSA1Ljc1IDkuNzVIOC43NUM5LjAyNjE0IDkuNzUgOS4yNSA5LjUyNjE0IDkuMjUgOS4yNUM5LjI1IDguOTczODYgOS4wMjYxNCA4Ljc1IDguNzUgOC43NUg1Ljc1WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";